// Keep the original hour values in saved trades; use consistent H1/H2 labels
// in the picker without rewriting anyone's existing execution history.
export const TRADE_TIMEFRAMES = [
  '', '5s', '10s', '15s', '30s', '45s',
  'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M10', 'M12', 'M15', 'M20', 'M30', 'M45',
  ['1H', 'H1'], ['2H', 'H2'], ['3H', 'H3'], ['4H', 'H4'],
  ['6H', 'H6'], ['8H', 'H8'], ['12H', 'H12'],
  'D1', 'W1', 'MN1',
];

// Older imports may use another spelling. Keep it selectable on edits so
// saving an unrelated detail never silently clears the original timeframe.
export function tradeTimeframeOptions(value) {
  if (!value || TRADE_TIMEFRAMES.some(option => (Array.isArray(option) ? option[0] : option) === value)) return TRADE_TIMEFRAMES;
  const alias = TRADE_TIMEFRAMES.find(option => Array.isArray(option) && option[1] === value);
  return alias ? TRADE_TIMEFRAMES.map(option => option === alias ? [value, alias[1]] : option) : [...TRADE_TIMEFRAMES, value];
}
